import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/Button';

export function NotFoundPage() {
  return (
    <div className="mx-auto max-w-md text-center">
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold-500">404</p>
      <h1 className="mt-3 display-serif text-display-l text-fg">Page not found.</h1>
      <p className="mt-3 text-sm text-fg-muted">The admin page you're looking for doesn't exist.</p>
      <div className="mt-6">
        <Button asChild>
          <Link to="/">Back to dashboard</Link>
        </Button>
      </div>
    </div>
  );
}